// ═══════════════════════════════════════════════════════════════════
//  GlobalSearchMount — Fixed-position SearchBar visible everywhere.
// ═══════════════════════════════════════════════════════════════════
//
//  FW has no global header — each page renders its own. Rather than
//  refactor every page, this component anchors the SearchBar to a
//  fixed position (top-right on desktop, full-width modal on mobile)
//  so it's reachable from every route.
//
//  Hidden on /search itself (the SearchCanvas page renders its own
//  header) — Phase E.
//
// ═══════════════════════════════════════════════════════════════════

import { useLocation } from 'react-router-dom';
import { SearchBar } from './SearchBar';

const HIDDEN_ROUTES: ReadonlyArray<RegExp> = [
  /^\/search/,        // Search canvas has its own header
  /^\/splash/,        // Marketing splash
  /^\/preview/,       // Preview shouldn't show app chrome
  /^\/flow-weaver/,   // Canvas page mounts the SearchBar inside the
                      // CanvasHud (movable container with zoom + search).
  /^\/atlas$/,        // Atlas main page mounts the SearchBar inline in
                      // its own sticky header strip — having both the
                      // fixed-position floater AND the inline one made
                      // the page header look unanchored.
  /^\/atlas\/canvas/, // Atlas mega-canvas mounts its own AtlasCanvasHud
                      // (movable search + zoom + ref-legend panel).
  /^\/atlas\/doc/,    // Atlas doc viewer mounts AtlasDocHud (movable
                      // search panel) — symmetry with the canvas page.
];

export function GlobalSearchMount() {
  const { pathname } = useLocation();
  const hidden = HIDDEN_ROUTES.some((r) => r.test(pathname));
  if (hidden) return null;

  return (
    <div
      className="fixed top-3 right-3 z-40 hidden md:flex items-center"
      data-fw-global-search="true"
    >
      <SearchBar />
    </div>
  );
}
